import { useEffect } from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { useSubscription } from '../contexts/SubscriptionContext';
import { useFunnel } from '../contexts/FunnelContext';
import { setAnalyticsUser, trackEvent, Events } from '../utils/webviewBridge';

/** Синхронизирует user properties и funnel mode с analytics bridge. */
const AnalyticsSync = () => {
  const { locale } = useLocale();
  const { guestId, hasAccess, subscription, onboardingComplete } = useSubscription();
  const { funnelMode } = useFunnel();

  useEffect(() => {
    setAnalyticsUser({
      guest_id: guestId,
      locale,
      has_access: hasAccess,
      onboarding_complete: onboardingComplete,
      funnel_mode: funnelMode,
      plan: subscription?.plan || null
    });
  }, [guestId, locale, hasAccess, onboardingComplete, funnelMode, subscription?.plan]);

  useEffect(() => {
    trackEvent(Events.FUNNEL_MODE_RESOLVED, { funnel_mode: funnelMode });
  }, [funnelMode]);

  return null;
};

export default AnalyticsSync;
